import PaymentStatusCell from './payment_status_cell';

export default PaymentStatusCell;
